<template>
  <div class="full-page" :class="{ 'nav-open': $sidebar.showSidebar }"> 

    <md-toolbar md-elevation="0" class="md-transparent md-toolbar-absolute">
      <div class="md-toolbar-section-start">
        <a class="navbar-brand" href="/">
          <md-avatar class="md-large app-logo">
            <img :src="images.logo" width="60" height="60" class="d-inline-block align-top" alt="System">
          </md-avatar>
        </a>
        <div class="title-white">
          <span class="md-display-2 title-white">
            Freedom 7
          </span>
          <br />
          <span class="md-subheading title-white">
            Siniestros Carreteros
          </span>
        </div>
      </div>
    </md-toolbar>

    <div class="wrapper wrapper-full-page" @click="toggleSidebarPage">
      <div
        class="page-header header-filter"
        :class="setPageClass"
        style="background-position: center bottom;"
        :style="setBgImage"
      >
        <div class="container md-offset">
          <zoom-center-transition
            :duration="pageTransitionDuration"
            mode="out-in"
          >
            <router-view></router-view>
          </zoom-center-transition>
        </div>

        <footer class="footer">
          <div class="container md-offset">
            <div class="copyright text-center">
              &copy; 2011-{{ new Date().getFullYear() }}
              <a
                href="http://www.jbgrupoempresarial.com.mx/"
                target="_blank"
                >
                JB Grupo Empresarial
              </a>
            </div>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
  import { ZoomCenterTransition } from "vue2-transitions"

  export default {
    components: { ZoomCenterTransition, },
    props: {
      backgroundColor: {
        type: String,
        default: "black"
      }
    },
    inject: {
      autoClose: {
        default: true
      }
    },
    data() {
      return {
        responsive: false,
        showMenu: false,
        menuTransitionDuration: 250,
        pageTransitionDuration: 300,
        year: new Date().getFullYear(),
        images: {
          logo: require('../assets/images/logo.jpg'),
        },
        bgImages: [
          require("../assets/images/login.jpg")
        ]
      }
    },
    computed: {
      setBgImage() {
        const { bgImages } = this
        const index  = Math.floor(Math.random() * bgImages.length)
        const img = bgImages[index]
        return {
          backgroundImage: `url(${img})`
        };
      },
      setPageClass() {
        return `${this.$route.name}-page`.toLowerCase()
      }
    },
    methods: {
      toggleSidebarPage() {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      },
      linkClick() {
        if (
          this.autoClose &&
          this.$sidebar &&
          this.$sidebar.showSidebar === true
        ) {
          this.$sidebar.displaySidebar(false)
        }
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      toggleNavbar() {
        document.body.classList.toggle("nav-open")
        this.showMenu = !this.showMenu;
      },
      closeMenu() {
        document.body.classList.remove("nav-open")
        this.showMenu = false;
      },
      onResponsiveInverted() {
        if (window.innerWidth < 991) {
          this.responsive = true
        } else {
          this.responsive = false
        }
      }
    },
    mounted() {
      this.onResponsiveInverted()
      window.addEventListener("resize", this.onResponsiveInverted)
    },
    beforeDestroy() {
      this.closeMenu();
      window.removeEventListener("resize", this.onResponsiveInverted)
    },
    beforeRouteUpdate(to, from, next) {
      // Close the mobile menu first then transition to next page
      if (this.showMenu) {
        this.closeMenu()
        setTimeout(() => {
          next()
        }, this.menuTransitionDuration)
      } else {
        next()
      }
    }
  }
</script>

<style lang="scss" scoped>
  $scaleSize: 0.1;
  $zoomOutStart: 0.7;
  $zoomOutEnd: 0.46;

  .navbar-brand {
    padding: 0 0;
  }

  .title-white { 
    color: white !important; 
    margin-left: 0.5em;
  }

  .app-logo,
  .title-white {
    opacity: 0.9;
  }

  .page-header {
    margin-top: 0;
    margin-bottom: 0;
  }

  @keyframes zoomIn8 {
    from {
      opacity: 0;
      transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
    100% {
      opacity: 1;
    }
  }
  .wrapper-full-page .zoomIn {
    animation-name: zoomIn8;
  }
  @keyframes zoomOut8 {
    from {
      opacity: 1;
      transform: scale3d($zoomOutStart, $zoomOutStart, $zoomOutStart);
    }
    to {
      opacity: 0;
      transform: scale3d($zoomOutEnd, $zoomOutEnd, $zoomOutEnd);
    }
  }
  .wrapper-full-page .zoomOut {
    animation-name: zoomOut8;
  }
</style>



// WEBPACK FOOTER //
// src/pages/AuthLayout.vue